var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBlackWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5957 19.9565V16.4391C8.5957 15.9 8.88306 15.4629 9.23754 15.4629H19.7307C20.0851 15.4629 20.3724 15.9 20.3724 16.4391V19.9565C20.3724 20.4956 20.0851 20.9327 19.7307 20.9327H9.23754C8.88306 20.9327 8.5957 20.4956 8.5957 19.9565Z",
    stroke: "#272727",
    strokeWidth: 1.008,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3848 20.9385V15.4805",
    stroke: "#272727",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8047 20.9385V15.4805",
    stroke: "#272727",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8158 15.024H8.88109C8.50066 14.6436 8.50051 11.4263 8.88094 11.0458L16.7715 3.34977C17.1519 2.96935 17.7687 2.96935 18.1491 3.34977L20.6307 5.83149C21.0112 6.21191 21.0112 6.8286 20.6307 7.20903L12.8158 15.024ZM12.8158 15.024C8.88094 15.024 13.1962 15.4044 12.8158 15.024Z",
    stroke: "#272727",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6592 11.2071L12.7998 7.34766",
    stroke: "#272727",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.128 13.7383L10.2686 9.87891",
    stroke: "#272727",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5225 14.707V19.963C8.5225 20.5011 8.08603 20.937 7.54799 20.937H4.03841C3.50036 20.937 3.06445 20.5011 3.06445 19.963V14.707",
    stroke: "#272727",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06445 14.7084V4.03841C3.06445 3.50036 3.50036 3.06445 4.03841 3.06445H7.54799C8.08603 3.06445 8.5225 3.50036 8.5225 4.03841V14.7084",
    stroke: "#272727",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96875 12.9482V8.92969",
    stroke: "#272727",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61523 12.9463V10.7695",
    stroke: "#272727",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63574 19.1719C6.63708 19.1719 6.63848 19.1719 6.63982 19.1719",
    stroke: "#272727",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5225 14.707H3.06445",
    stroke: "#272727",
    strokeWidth: 1.008,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlackWhite);
export default __webpack_public_path__ + "static/media/icon-black-white.7924b7e58f661ed73e4e3c4fe0352696.svg";
export { ForwardRef as ReactComponent };